import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13d225b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-close-fill" }, null, -1))
const _hoisted_3 = { class: "title-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-paw" }, null, -1))
const _hoisted_5 = { class: "stake-content main-content" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "input-row" }
const _hoisted_8 = { class: "input-wrapper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "asterisk" }, "*", -1))
const _hoisted_10 = { class: "btn-content" }
const _hoisted_11 = { class: "hint-row" }

import {
  computed, ref,
} from 'vue';

import FarmDialogType from '@/types/token-farm';


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: Boolean,
  type: {
    default: FarmDialogType.stake,
    type: String,
  },
  data: Object,
},
  emits: ['update:visible', 'submit'],
  setup(__props, { emit }) {

const props = __props


const input = ref('');
const isMax = ref(false);


const innerVisible = computed({
  get: () => props.visible,
  set: (val: boolean) => emit('update:visible', val),
});

function maxClick() {
  isMax.value = true;
  input.value = '0';

  if (props.data !== undefined) {
    if (props.type === FarmDialogType.stake) {
      input.value = props.data.tokenAmount;
    } else {
      input.value = props.data.myStaked;
    }
  }
}

function doClick() {
  let amount = input.value;
  if (props.type === FarmDialogType.unstake && isMax.value && props.data !== undefined) {
    amount = props.data.myStakedOriginal;
  }
  emit('submit', { amount, isMax: isMax.value });

  innerVisible.value = false;
}

function beforeClose() {
  input.value = '';
  isMax.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(innerVisible),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(innerVisible) ? (innerVisible).value = $event : null)),
    "custom-class": "neco-dialog stake-dialog",
    width: "600px",
    "show-close": false,
    onClosed: beforeClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (innerVisible.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$t(__props.type)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (__props.type === _unref(FarmDialogType).stake)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('availableToStake')) + ": " + _toDisplayString(__props.data.tokenAmount), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('availableToUnStake')) + ": " + _toDisplayString(__props.data.myStaked), 1)
                ], 64))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_el_button, {
                class: "btn percent-btn",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "btn-content",
                    onClick: maxClick
                  }, "Max")
                ]),
                _: 1
              }),
              _createVNode(_component_el_input, {
                modelValue: input.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((input).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_el_button, {
              onClick: doClick,
              class: "btn approve-btn",
              size: "medium"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('do')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('withdrawHint')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})